import { render, staticRenderFns } from "./make-payment-thank-you.vue?vue&type=template&id=37f93dbc&scoped=true&"
import script from "./make-payment-thank-you.vue?vue&type=script&lang=js&"
export * from "./make-payment-thank-you.vue?vue&type=script&lang=js&"
import style0 from "./make-payment-thank-you.vue?vue&type=style&index=0&id=37f93dbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f93dbc",
  null
  
)

export default component.exports